const translations = {
  "en": {
    "last 24hrs": "last 24hrs"
  },
  "zh-tw": {
    "last 24hrs": "過去 24 小時"
  }
};

export default translations;
